// The Main Site Object
window.Site = {

    // Marquee text items and settings
    marqueeText     : document.querySelector('.marquee'),
    marqueeChunk    : document.querySelector('.marquee-chunk'),
    marqueeInterval : null,
    marqueeSpeed    : 20,
    marqueeAudio    : document.querySelector('#marquee'),

    // Intro Block Items
    introText   : document.querySelector('.intro-container'),
    introButton : document.querySelector('.intro-button'),

    // Hashtag Container
    hashtags : document.querySelector('.hashtags-list'),
    posts    : document.querySelectorAll('.post'),

    // Color Scheme Button
    btnScheme : document.querySelector('.js-scheme'),

    notificationContainer : document.querySelector('.notifications'),
    notificationButton    : document.querySelector('.header-notifications'),

    // Navigation
    menuBtn       : document.querySelector('.menu-btn'),
    menuContainer : document.querySelector('.menu'),

    // Init Function 
    liftoff : () => {
        //Site.onClickRemoveCookieBanner()
        //Site.onLoadDisplayCookieBanner()
        Site.onClickShowHideIntro()
        Site.onClickToggleColorScheme()
        Site.onLoadSetUpTheSchemeButton()
        Site.onClickToggleNotificationConter()
        Site.onClickToggleMenu()
        Site.configMarqueeAudio()
        Site.restoreScrollPosition()
        Site.startMarquee()

    },

    // The Control Center
    Controls : {

        // Toggle the icons on click
        toggleIcon : (parent) => {
            parent.querySelectorAll('.icon').forEach(icon => {
                icon.classList.toggle('icon-active')
            })
        },

        // Toggle the active class for the button
        toggleClasses : (parent,classA,classB) => {
            parent.classList.toggle(classA)
            parent.classList.toggle(classB)
        }

    },

    // Generate The Cookie Banner
    onClickRemoveCookieBanner : () => {

        if (!Site.cookieBannerButton) return;

        Site.cookieBannerButton.addEventListener('click' , () => {

            if (localStorage.banner !== 'displayed')
                localStorage.banner = 'displayed';

            // Remove The Banner
            document.querySelector('.gocciola').remove();

        })
    },

    // We need to create and display the cookie banner
    onLoadDisplayCookieBanner : () => {

        if (localStorage.banner !== 'displayed') {
            

            // Create the banner DOM 
            Site.banner = document.createElement('div');
            Site.banner.classList.add('gocciola');

            // The Left Column
            Site.bannerText = document.createElement('div');
            Site.bannerText.classList.add('gocciola-text');

            // The Right Column
            Site.bannerButton = document.createElement('div');
            Site.bannerButton.classList.add('gocciola-button');


            // We need to create the content for the two columns
            Site.bannerTextContent  = document.createElement('p')
            Site.bannerButtonContent = document.createElement('button')

            // Set the text message
            Site.bannerTextContent.innerHTML  = "We use technical cookies"
            Site.bannerButtonContent.innerHTML = "Go away"

            // Append the two columns to the main banner
            Site.bannerText.appendChild(Site.bannerTextContent)
            Site.bannerButton.appendChild(Site.bannerButtonContent)

            // Append the two columns to the main banner
            Site.banner.appendChild(Site.bannerText)
            Site.banner.appendChild(Site.bannerButton)

            // Append the banner to the body
            document.body.appendChild(Site.banner);

        }

    },


    // On click show/hide the text intro
    onClickShowHideIntro : () => {

        // If we don't have button and text do nothing
        if (!Site.introText || !Site.introButton) return;

        Site.introButton.addEventListener('click' , () => {

            Site.introButton.innerHTML = (Site.introButton.innerHTML == 'Read More') ? 'Close' : 'Read More';

            Site.introText.classList.toggle('open')
            document.body.classList.toggle('intro-open')


        })
        

    },

    // On click toggle the color scheme
    onClickToggleColorScheme : () => {


        Site.btnScheme.addEventListener('click' , () => {

            (localStorage.theme === 'inverted') ? document.documentElement.classList.remove('inverted')  : document.documentElement.classList.add('inverted');
            (localStorage.theme === 'inverted') ? localStorage.removeItem('theme') : localStorage.theme = 'inverted';

            Site.Controls.toggleIcon(Site.btnScheme)
            Site.Controls.toggleClasses(Site.btnScheme , 'is-day' , 'is-night')
    
        })
    },

    // Set up the correct icon for the color scheme
    onLoadSetUpTheSchemeButton : () => {
        if (localStorage.theme === 'inverted') {        
            window.addEventListener('load' , () => {

                let button = document.querySelector('.js-scheme')

                button.classList.toggle('is-day')
                button.classList.toggle('is-night')

                button.children[0].classList.toggle('icon-active')
                button.children[1].classList.toggle('icon-active')
            })
        }
    },

    // SHOW/HIDE the notification center
    onClickToggleNotificationConter : () => {
        Site.notificationButton.addEventListener('click' , () => {
            if (Site.notificationButton.classList.contains('is-disabled')) return;
            Site.notificationContainer.classList.toggle('open')
        })
    },

    // Toggle The Menu On Click
    onClickToggleMenu : () => {
        Site.menuBtn.addEventListener('click' , () => {
            Site.menuContainer.classList.toggle('is-open')
            document.body.classList.toggle('menu-is-open')
        })
    },

    // Set up the play/pause of the marquee audio
    configMarqueeAudio : () => {

        document.body.addEventListener('click' , () => {
            Site.soundCall = document.querySelector('#audiocall')
            Site.soundPing = document.querySelector('#audionotification')
            Site.soundText = document.querySelector('#audiomarquee')
        })

        window.addEventListener('load' , () => {

            Site.marqueeText.addEventListener('mouseenter' , () => {
                Site.soundText.play()
            })

            Site.marqueeText.addEventListener('mouseleave' , () => {
                Site.soundText.pause()
            })

        })

    },

    restoreScrollPosition : () => {
        window.onbeforeunload = function () {
            window.scrollTo(0, 0);
        }
    },

    startMarquee : () => {
        if (!Site.marqueeText) return;
        document.addEventListener('DOMContentLoaded' , () => {
            setTimeout(function(){Site.marqueeText.classList.add('animated')} , 1000)
        })
    }


}

// Launch The Script
Site.liftoff()